'use strict';

var React = require('react');
require('../utils/assertion.js');
var _function = require('../utils/function.js');
var isIframe = require('../utils/iframeUtils/isIframe.js');
var checkIsAppleDevice = require('../utils/checkIsAppleDevice.js');
var isTVisualViewportMessage = require('../utils/isTVisualViewportMessage.js');

const isIframeOnce = isIframe.isIframe();
const resizeHandler = ({ footerElement, enabled, visualViewportHeight, innerHeight, setIsTransformed, }) => {
    const isAllowedExecute = footerElement && enabled;
    if (!isAllowedExecute || typeof footerElement.getBoundingClientRect !== 'function' || !visualViewportHeight) {
        setIsTransformed(false);
        return;
    }
    const rect = footerElement.getBoundingClientRect();
    const shouldTransform = visualViewportHeight + rect.height < innerHeight;
    const bottomOffset = innerHeight - visualViewportHeight;
    footerElement.style.transform = `translateY(-${shouldTransform ? bottomOffset : 0}px)`;
    setIsTransformed(shouldTransform);
};
const scrollHandler = ({ footerElement, enabled, visualViewportHeight, innerHeight, visualViewportOffsetTop, setIsTransformed, }) => {
    const isAllowedExecute = footerElement && enabled;
    if (isAllowedExecute && visualViewportHeight && typeof visualViewportOffsetTop === 'number') {
        const innerHeightWithOffset = checkIsAppleDevice.checkIsAppleDevice() ? visualViewportOffsetTop + innerHeight : innerHeight;
        const bottomOffset = innerHeightWithOffset - visualViewportHeight - visualViewportOffsetTop;
        const shouldTransform = bottomOffset > 0;
        footerElement.style.transform = `translateY(-${shouldTransform ? bottomOffset : 0}px)`;
        setIsTransformed(shouldTransform);
        return;
    }
    setIsTransformed(false);
};
const handleIframeViewportMessage = ({ footerElement, enabled, visualViewportHeight, innerHeight, visualViewportPageTop = 0, iframeOffsetTop, setIsTransformed, }) => {
    const isAllowedExecute = footerElement && enabled;
    if (isAllowedExecute && visualViewportHeight) {
        // innerHeight - visualViewportHeight - оставшееся расстояние на экране после открытия клавиатуры
        // iframeOffsetTop - расстояние от верха iframe до верха страницы
        // visualViewportPageTop - Y координата вьюпорта
        const bottomOffset = innerHeight - visualViewportHeight + iframeOffsetTop - visualViewportPageTop;
        const shouldTransform = bottomOffset > 0;
        footerElement.style.transform = `translateY(-${shouldTransform ? bottomOffset : 0}px)`;
        setIsTransformed(true);
        return;
    }
    setIsTransformed(false);
};
const THROTTLE_WAIT = 300;
const throttledHandleMessageInIframe = _function.throttle(handleIframeViewportMessage, THROTTLE_WAIT);
/***
 * Хук для изменения положения sticky элемента при изменении размеров окна браузера и последующем скролле.
 *  @param {React.RefObject<HTMLElement>} ref - Ref sticky элемента.
 *  @param {boolean} enabled - Включает или выключает функциональность.
 *  @returns {{ isTransformed: boolean }} - Показывает применяются ли стили для изменения положения элемента
 ***/
const useStickyDiv = (ref, enabled = true) => {
    const [isTransformed, setIsTransformed] = React.useState(false);
    React.useEffect(() => {
        if (isIframeOnce) {
            const handleMessageInIframe = (e) => {
                const { data } = e || {};
                if (isTVisualViewportMessage.isIVisualViewportResizeMessage(data) || isTVisualViewportMessage.isIVisualViewportScrollMessage(data)) {
                    throttledHandleMessageInIframe({
                        footerElement: ref.current,
                        enabled,
                        visualViewportHeight: data.visualViewport?.height,
                        innerHeight: data.innerHeight,
                        setIsTransformed,
                        visualViewportPageTop: data.visualViewport?.pageTop,
                        iframeOffsetTop: data.iframeOffsetTop,
                    });
                }
            };
            window.addEventListener('message', handleMessageInIframe);
            return () => {
                window.removeEventListener('message', handleMessageInIframe);
            };
        }
        const handleResizeNonIframe = () => {
            resizeHandler({
                footerElement: ref.current,
                enabled,
                visualViewportHeight: window.visualViewport?.height,
                innerHeight: window.innerHeight,
                setIsTransformed,
            });
        };
        const handleScrollNonIframe = () => {
            scrollHandler({
                footerElement: ref.current,
                enabled,
                visualViewportHeight: window.visualViewport?.height,
                innerHeight: window.innerHeight,
                visualViewportOffsetTop: window.visualViewport?.offsetTop,
                setIsTransformed,
            });
        };
        handleResizeNonIframe();
        const throttledHandleResizeNonIframe = _function.throttle(handleResizeNonIframe, THROTTLE_WAIT);
        const throttledHandleScrollNonIframe = _function.throttle(handleScrollNonIframe, THROTTLE_WAIT);
        window.visualViewport?.addEventListener('resize', throttledHandleResizeNonIframe);
        window.visualViewport?.addEventListener('scroll', throttledHandleScrollNonIframe);
        return () => {
            window.visualViewport?.removeEventListener('resize', throttledHandleResizeNonIframe);
            window.visualViewport?.removeEventListener('scroll', throttledHandleScrollNonIframe);
        };
    }, [enabled, ref]);
    return { isTransformed };
};

exports.useStickyDiv = useStickyDiv;
//# sourceMappingURL=useStickyDiv.js.map
